
export const backgroundAccent = '#303f9f';
export const pageWidth = '1200px';
